<template>
  <v-dialog
    persistent
    scrollable
    content-class="dialog-fullscreen-floating"
    v-model="isOpened"
  >
    <v-card>
      <v-card-title class="pl-4">
        <v-btn icon class="mr-3" @click="isOpened = false">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-icon small color="accent" class="mr-2 font-weight-bold">bookmark</v-icon>
        Détails d'une intervention
        <v-spacer />
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0" v-if="id">
        <intervention
          :id="id"
          in-dialog
          @change="$emit(`change`)"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Intervention from '@/components/Interventions/Intervention.vue';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {},
  },
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  components: {
    Intervention,
  },
};
</script>

<style lang="scss">
</style>
